import { Loader } from '@insify/design-system/components';

import * as styles from './LoaderSmall.module.css';

export const LoaderSmall = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
      <Loader loading className={styles.loader} />
    </div>
  );
};
